import tools from  '@/api/tools.js';

import headbar from "@/component/headbar.vue"; 
import footbar from "@/component/footbar.vue"; 
import bread from "@/component/bread.vue";  

Vue.component('headbar',headbar);
Vue.component('footbar',footbar);
Vue.component('bread',bread);


var vm = new Vue({
    el : '.root'
    ,data:{
        id : util.parse_query().id || ''
        ,type : util.parse_query().type || ""
        ,info:{}
        ,iframe_height : 100
    }
    ,mounted:async function(){
        await this[this.type]();
        // this.set_content()
    }
    ,methods:{
        preaudit: async function(){
            var res = await tools.ajax({
                url : call.DataSyncApi_QulifyBulletin + `/id/${this.id}`
                ,method : 'get'
            });
            res = res[0];
            var map = res.data.data[0] || {};
            this.info.name  = map.bulletinname;
            this.info.code = map.bidsectioncodes;
            this.info.content = map.bulletincontent;
            this.$forceUpdate();
        }
        ,set_content(){
            var iframe = document.querySelector(".iframe")
            var iframe_window = iframe.contentWindow
            var iframe_document = iframe_window.document
            iframe_document.body.innerHTML = this.info.content
            var me = this
            setTimeout(()=>{
                me.iframe_height = iframe_document.body.scrollHeight
            },500)
        }
        ,bids: async function(){
            var res = await tools.ajax({
                url : call.DataSyncApi_TenderBulletin + `/id/${this.id}`
                ,method : 'get'
            })
            res = res[0];
            var map = res.data.data[0] || {};
            this.info.name  = map.bulletinname;
            this.info.code = map.bidsectioncodes;
            this.info.content = map.bulletincontent;
            this.$forceUpdate();
        }
        ,candidate: async function(){
            var res = await tools.ajax({
                url : call.DataSyncApi_WinCandidateBulletin + `/id/${this.id}`
                ,method : 'get'
            })
            res = res[0];
            var map = res.data.data[0] || {};
            this.info.name  = map.publicityname;
            this.info.code = map.bidsectioncodes;
            this.info.content = map.publicitycontent;
            this.$forceUpdate();
        }
        ,result: async function(){
            var res = await tools.ajax({
                url : call.DataSyncApi_WinBidBulletin + `/id/${this.id}`
                ,method : 'get'
            })
            res = res[0];
            var map = res.data.data[0] || {};
            this.info.name  = map.bulletinname;
            this.info.code = map.bidsectioncodes;
            this.info.content = map.bulletincontent;
            this.$forceUpdate();
        }
        ,to_top(){
            $(window).scrollTop(0);
        }
    }
    
})